module.exports = __webpack_public_path__ + "img/step_info.3655ef69.png";